import VisitCounter from "./VisitCounter";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SHOP_URL, NAV_LINKS } from "../data/content";
import { BrandGlyph } from "./NavigationHeader";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.07] bg-[#0C0E14]/70">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 lg:px-10 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3">
              <BrandGlyph size={32} />
              <span className="font-display text-2xl text-[#F0F2F8]">
                Consciousness Ascending
              </span>
            </div>
            <p className="body-muted mt-6 max-w-md text-sm leading-relaxed">
              Systematic protocols for non-local perception and beyond-body
              consciousness. Sovereign discernment, stargate-era discipline —
              your own remote path.
            </p>
            <a
              data-testid="footer-shop-link"
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 border border-[#8B5CF6]/40 px-5 py-3 font-mono-ui text-[11px] uppercase tracking-[0.2em] text-[#F0F2F8] transition-all duration-300 hover:border-[#8B5CF6] hover:bg-[#8B5CF6]/15 hover:shadow-[0_0_20px_rgba(139,92,246,0.3)]"
            >
              consciousness-ascending-shop.fourthwall.com
              <ArrowUpRight className="h-3.5 w-3.5 text-[#A78BFA]" />
            </a>
          </div>

          <nav className="lg:col-span-3" aria-label="Footer">
            <p className="eyebrow">Navigate</p>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.id}`}
                    className="text-sm text-[#8E95A5] transition-colors duration-300 hover:text-[#A78BFA]"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-3">
            <p className="eyebrow">Disciplines</p>
            <ul className="mt-6 space-y-3 text-sm text-[#8E95A5]">
              <li>Coordinate Remote Viewing</li>
              <li>Astral Projection & the Gateway State</li>
              <li>Field Workbooks & Ledgers</li>
            </ul>
          </div>
        </div>

        <VisitCounter />

        <div className="mt-16 flex flex-col gap-4 border-t border-white/[0.06] pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono-ui text-[10px] uppercase tracking-[0.2em] text-[#5F6677]">
            © {new Date().getFullYear()} Consciousness Ascending — Your Own Remote Path
          </p>
          <p className="max-w-xl font-mono-ui text-[10px] leading-relaxed tracking-[0.08em] text-[#5F6677]">
            Educational material for reflection and personal exploration. Not
            medical or psychological advice. Purchases are fulfilled externally
            via Fourthwall.
          </p>
        </div>
      </div>
    </footer>
  );
}
